// @flow
import { Dispatcher } from 'flux';

interface IDispatchEvent {
  type: string;
  payload: any;
}

const DISPATCH_EVENT: IDispatchEvent = {
  type: '',
  payload: null
};

class AppDispatcher extends Dispatcher {

}
const dispatcher = new AppDispatcher();

export default dispatcher;
export function dispatch(event: string, payload: any): void {
  DISPATCH_EVENT.type = event;
  DISPATCH_EVENT.payload = payload;
  dispatcher.dispatch(DISPATCH_EVENT);
}
